/* eslint-disable no-plusplus */
import { Col, Row, Spin, Button, Select, Radio, Alert } from 'antd';
import { Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import React, { Suspense, useEffect, useState, useMemo } from 'react';
// import parse from 'html-react-parser';
import {
  AVAILABILITY_ANSWERS_FOR_JOB_REQUEST_FORM,
  DEVELOPER_AVAILABILITY_TYPES,
  DEVELOPER_AVAILABILITY_TYPES_NEW
} from '../developer-availability-statuses/developer-availability-statuses.types';

import { required } from '../validations';
import {
  RenderRadioGroup,
  RenderCheckboxField,
  RenderTextArea,
  SubmitButton,
  RenderSelectField,
  RenderFloatField,
} from '../render-form-fields/RenderFormFields';
import {
  convertTimezoneClosure,
  getUTCTimezoneLabel,
  toAmPM,
} from '../../../services/util/timezone';
import { MONTHLY_HOURS_OF_WORK, formatValueAsCurrency } from '../../../services/util/currency';
import AvailabilityModalV3 from '../../../legacy_components/UI_V2_Components/profile/Modals/availibilityv3.modal'
import { UpdateRateModal } from '../update-rate-modal/UpdateRateModal';
import { ReactComponent as InfoSvg } from '../../../assets/img/info.svg';
import { closedJobStatuses } from '../enum';
import { ReactComponent as ErrorIndicatorSvg } from '../../../assets/img//error-indicator.svg';
import {CustomQuestionField} from "./CustomQuestionField";

const UpdateMonthlyCompensationModal = React.lazy(() =>
  import('../update-monthly-compensation-modal/UpdateMonthlyCompensationModal').then(({ UpdateMonthlyCompensationModal: Cmp }) => ({
    default: Cmp,
  })),
);

const ConfirmSalaryUpdateModal = React.lazy(() =>
  import('./ConfirmSalaryUpdateModal').then(({ ConfirmSalaryUpdateModal: Cmp }) => ({
    default: Cmp,
  })),
);

const ApplyToAllJobsModal = React.lazy(() =>
  import('./ApplyToAllJobsModal').then(({ ApplyToAllJobsModal: Cmp }) => ({
    default: Cmp,
  })),
);

const ConfirmRateChangeModal = React.lazy(() =>
  import('./ConfirmRateChangeModal').then(({ ConfirmRateChangeModal: Cmp }) => ({
    default: Cmp,
  })),
);

const UPDATE_RATE_MODAL = 'UPDATE_RATE_MODAL';
const CONFIRM_UPDATE_MODAL = 'CONFIRM_UPDATE_MODAL';
const APPLY_TO_ALL_MODAL = 'APPLY_TO_ALL_MODAL';
const HOURLY = 'HOURLY';
const MONTHLY = 'MONTHLY';

export const getJobInterestFormDefaultValuesIfNull = (
  values$1,
  developerInfo,
  isNegotiatedOrNewDesiredSalaryPresent$1,
  isDeveloperAvailabilityPresent$1,
  developerAvailability,
  timezones,
  isProxyApplication,
  isNegotiatedOrNewDesiredSalaryPresentV2$1,
  enableIcfRateV2$1,
) => {
  const values = { ...values$1 };
  const icfIsSubmitted = values.submittedAt;
  const savedFormData = localStorage.getItem(`icf_form_${values.idHash}`);
  if (!icfIsSubmitted && savedFormData) {
    const { formData } = JSON.parse(savedFormData);
    // if (values.devRateChangeAttemptValue ) {
    //   formData.newDesiredSalaryHourly = values.devRateChangeAttemptValue;
    //   formData.newDesiredSalaryMonthly = values.devRateChangeAttemptValue * MONTHLY_HOURS_OF_WORK;
    // }
    if (!formData.rateType) {
      formData.rateType = HOURLY;
    }

    return formData;
  }
  if (values.isInterested === null || values.isInterested === undefined) {
    values.isInterested = true;
  }

  if (!values.rateType) {
    values.rateType = HOURLY;
  }
  if (
    isProxyApplication &&
    (values.availabilityConfirmed === null || values.availabilityConfirmed === undefined)
  ) {
    values.availabilityConfirmed = isDeveloperAvailabilityPresent$1;
  }

  if (
    isProxyApplication &&
    (values.canOverlapWithTimezone === null || values.canOverlapWithTimezone === undefined)
  ) {
    values.canOverlapWithTimezone = true;
  }

  if (
    isProxyApplication &&
    (values.salaryConfirmed === null ||
      values.salaryConfirmed === undefined ||
      values.isSubmitAllowed)
  ) {
    if (enableIcfRateV2$1) {
      values.salaryConfirmed = isNegotiatedOrNewDesiredSalaryPresentV2$1;
    } else {
      values.salaryConfirmed = isNegotiatedOrNewDesiredSalaryPresent$1;
    }
  }

  if (!values.developerTimezoneId && developerInfo) {
    let developerTimezoneId = null;
    if (developerInfo.utcTimezone) {
      developerTimezoneId = timezones.find((tz) => tz.name === developerInfo.utcTimezone) || {};
      developerTimezoneId = developerTimezoneId.id
    }
    if (!developerTimezoneId && developerInfo.countryId) {
      developerTimezoneId = timezones.find((tz) => tz.countryId === developerInfo.countryId) || {};
      developerTimezoneId = developerTimezoneId.id
    }
    values.developerTimezoneId = developerTimezoneId;
  }

  if (values.devRateChangeAttemptValue) {
    values.newDesiredSalaryHourly = values.devRateChangeAttemptValue;
    values.newDesiredSalaryMonthly = values.devRateChangeAttemptValue * MONTHLY_HOURS_OF_WORK;
  }

  if (values.advancedConfiguration) {
    values.customQuestionAnswerJson = values.customQuestionAnswerJson?.map((question) => {
      if (question.inputType === 'noticePeriod') {
        return {
          ...question,
          answer: developerAvailability.noticePeriod
        };
      }
      return question;
    });
    values.availabilityConfirmed = true;
  }

  return values;
};

export function JobInterestFormFields({
  isProxyApplication = false,
  submitting,
  pristine,
  values,
  jobInterest,
  jobInterestDefaultDetails,
  developerInfo,
  developerAvailability,
  developerRateDetails,
  notInterestedReasons,
  setDeveloperAvailability,
  setDeveloperExpectedRateDetails,
  saveRateChangeAttempt,
  createdByEmail,
  isVetsmithFlow,
  jobMatchingVetsmithFlag,
  isAvailabilityUnknown,
  setIsAvailabilityUnknown,
  isSubmitAllowed,
  isNegotiatedOrNewDesiredSalaryPresent,
  setIsNegotiatedOrNewDesiredSalaryPresent,
  isNegotiatedOrNewDesiredSalaryPresentV2,
  setIsNegotiatedOrNewDesiredSalaryPresentV2,
  isDeveloperAvailabilityPresent,
  setIsDeveloperAvailabilityPresent,
  timezones,
  formErrors,
  onDeveloperAvailabilityChange,
  jobInfo,
  blockSubmissionReason,
}) {
  const [isAvailabilityModalVisible, setAvailabilityModalVisible] = useState(false);
  const [isMonthlyCompensationModalVisible, setIsMonthlyCompensationModalVisible] = useState(false);
  const [changeConformationPopupVisible, setChangeConformationPopupVisible] = useState(false);
  const [isAvailabilityModalLoading, setIsAvailabilityModalLoading] = useState(false);
  const [isSalaryModalLoading, setIsSalaryModalLoading] = useState(false);
  const [submittedOnce, setSubmittedOnce] = useState(false);

  // possible modal types UPDATE_RATE_MODAL, CONFIRM_UPDATE_MODAL, APPLY_TO_ALL_MODAL
  const [modalType, setModalType] = useState(null);
  const [numberOfAttempts, setNumberOfAttempts] = useState(jobInterest.devRateChangeAttempt || 0);
  const [temporaryRateData, setTemporaryRateData] = useState(null);
  const [isJobClosedForJRFSubmission, setIsJobClosedForJRFSubmission] = useState(false);

  const defaultTimezoneId = 93;
  const defaultOverlapHours = 4;
  const enableIcfRateV2 = true;
  const allowedAttempts = 2;
  const enableAcademicFields = false;
  const disablePerfectFitQuestion = true;

  /**
   * This portion of code deals with disabling the JRF
   * if the position has been closed for JRF submission.
   */
  useEffect(() => {
    if (jobInfo && jobInfo.jobStatusId) {
      const closedStatuses = Object.values(closedJobStatuses);
  
      if (closedStatuses.includes(jobInfo.jobStatusId)) {
        setIsJobClosedForJRFSubmission(true);
      } else {
        setIsJobClosedForJRFSubmission(false);
      }
    }
  }, [jobInfo?.jobStatusId]);

  const advancedConfiguration = jobInterestDefaultDetails.advancedConfiguration;

  const interestQuestion = useMemo(() => {
    if (!advancedConfiguration) {
      return null;
    }
    return jobInterestDefaultDetails.customQuestionAnswerJson?.find(it => it.inputType === 'interest');
  }, [advancedConfiguration, jobInterestDefaultDetails.customQuestionAnswerJson]);

  // eslint-disable-next-line no-param-reassign
  jobInterestDefaultDetails.jobOverlapHours =
    jobInterestDefaultDetails.jobOverlapHours ? jobInterestDefaultDetails.jobOverlapHours : defaultOverlapHours;

  if (!jobInterestDefaultDetails.jobTimezone) {
    const defaultTimezone = timezones.find((tz) => tz.id === +defaultTimezoneId);
    // eslint-disable-next-line no-param-reassign
    jobInterestDefaultDetails.jobTimezone = defaultTimezone;
  }

  useEffect(() => {
    let isUnknown = false;
    if (
      developerAvailability &&
      (developerAvailability.availabilityTypeId === 'unknown' ||
        developerAvailability.availabilityAnswer === 'unknown')
    ) {
      isUnknown = true;
    }
    setIsAvailabilityUnknown(isUnknown);
  }, [developerAvailability]);

  const findAvailabilityAnswerLabel = (availabilityAnswer) => {
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const key in AVAILABILITY_ANSWERS_FOR_JOB_REQUEST_FORM) {
      const element = AVAILABILITY_ANSWERS_FOR_JOB_REQUEST_FORM[key];
      if (element.key === availabilityAnswer) return element.label;
    }
    return null;
  };

  const closeModal = () => {
    setModalType(null);
  };

  const findAvailabilityTypeIdLabel = (availabilityTypeId) => {
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const key in DEVELOPER_AVAILABILITY_TYPES) {
      const element = DEVELOPER_AVAILABILITY_TYPES[key];
      if (element.key === availabilityTypeId) return element.label;
    }

    for (const key in DEVELOPER_AVAILABILITY_TYPES_NEW) {
      const element = DEVELOPER_AVAILABILITY_TYPES_NEW[key];
      if (element.key === availabilityTypeId) return element.label;
    }
  };

  if (
    (jobInterest.newDesiredSalaryHourly ||
      jobInterest.devNteHourlyRate > 0 ||
      jobInterest.devRateChangeAttemptValue) &&
    !isNegotiatedOrNewDesiredSalaryPresentV2
  ) {
    setIsNegotiatedOrNewDesiredSalaryPresentV2(true);
  }

  if (
    (jobInterest.newDesiredSalaryMonthly || developerRateDetails.monthlyRateInUSD > 0) &&
    !isNegotiatedOrNewDesiredSalaryPresent
  ) {
    setIsNegotiatedOrNewDesiredSalaryPresent(true);
  }

  if (Object.keys(developerAvailability).length !== 0 && !isDeveloperAvailabilityPresent) {
    setIsDeveloperAvailabilityPresent(true);
  }

  const onMonthlyCompensationChange = (salaryPresent) => {
    if (salaryPresent) {
      setChangeConformationPopupVisible(true);
    } else {
      setIsMonthlyCompensationModalVisible(true);
    }
  };

  const customerWorkHoursStart = '08:00';
  const customerWorkHoursEnd = '17:00';

  const renderConvertedDeveloperWorkHours = () => {
    const developerUtcTimezone = timezones.find((tz) => tz.id === values.developerTimezoneId);
    if (!developerUtcTimezone) {
      if (developerInfo.workingHours) {
        return `${toAmPM(developerInfo.workingHours.timeFrom)} to ${toAmPM(
          developerInfo.workingHours.timeTo,
        )} PST/PDT`;
      }
      return null;
    }

    const fromCustomerToDeveloperTime = convertTimezoneClosure(
      jobInterestDefaultDetails.jobTimezone.name,
      developerUtcTimezone.name,
    );
    return `${fromCustomerToDeveloperTime(customerWorkHoursStart)} to ${fromCustomerToDeveloperTime(
      customerWorkHoursEnd,
    )} ${developerUtcTimezone.popularName || developerUtcTimezone.name || ''}`;
  };

  const renderRateRow = (label, value, currency, type) => (
    <Row style={{ marginBottom: 5 }}>
      <Col lg={6} className="job-interest-form__question__info-bold">
        {label}:
      </Col>
      <Col>{`${formatValueAsCurrency(value, currency)} / ${type === HOURLY ? 'hr' : 'month'}`}</Col>
    </Row>
  );

  const renderRateInfo = () => {
    if (isNegotiatedOrNewDesiredSalaryPresentV2) {
      const rateUSD =
        values.rateType === HOURLY
          ? values.newDesiredSalaryHourly ? values.newDesiredSalaryHourly : jobInterest.devNteHourlyRate
          : (values.newDesiredSalaryHourly ? values.newDesiredSalaryHourly : jobInterest.devNteHourlyRate) *
          MONTHLY_HOURS_OF_WORK;

      const convertedLocalRate =
        (values.newDesiredSalaryHourly ? values.newDesiredSalaryHourly : jobInterest.devNteHourlyRate) *
        jobInterest.devCurrencyRate;
      return (
        <>
          {renderRateRow('Rate in USD', rateUSD, 'USD', values.rateType)}

          {jobInterest.devCurrency &&
            jobInterest.devCurrency !== 'USD' &&
            renderRateRow(
              `Rate in ${jobInterest.devCurrency}`,
              values.rateType === HOURLY
                ? convertedLocalRate
                : convertedLocalRate * MONTHLY_HOURS_OF_WORK,
              jobInterest.devCurrency,
              values.rateType,
            )}
        </>
      );
    }
    return <p className="job-interest-form__question__info">Your expected salary is not set.</p>;
  };

  const saveRateForm = (formValues) => {
    saveRateChangeAttempt(jobInterest.idHash, { rate: formValues.newDesiredSalaryHourly });
    setNumberOfAttempts(numberOfAttempts + 1);
    setDeveloperExpectedRateDetails({
      ...values,
      ...formValues,
    });
    setIsNegotiatedOrNewDesiredSalaryPresentV2(true);
    setTemporaryRateData(null);
  };

  const isMaxAttemptsReached = numberOfAttempts === allowedAttempts;

  const showOldCustomQuestion =
    jobInterestDefaultDetails.customQuestion &&
    !(jobInterestDefaultDetails.customQuestionAnswerJson || []).length > 0;

  const showPerfectFitQuestion =
    Boolean(jobInterest.submittedAt && jobInterest.perfectFitQuestionAnswer) ||
    !disablePerfectFitQuestion;

  let sectionCount = 0;

  const rateIsHigherThanMaxAccepted =
    ((jobInterest.devNteHourlyRate &&
      !values.newDesiredSalaryHourly &&
      jobInterest.devNteHourlyRate > jobInterest.devMaxRate) ||
      (values.newDesiredSalaryHourly && values.newDesiredSalaryHourly > jobInterest.devMaxRate)) &&
    jobInterest.devNteHourlyRate;

  const disclaimerMessage = `Disclaimer: $1 USD equals ${formatValueAsCurrency(
    jobInterest.devCurrencyRate,
    jobInterest.devCurrency,
  )} ${jobInterest.devCurrency}.`;

  const disclaimerParagraph = (
    <p className="job-interest-form__question__info-small">
      {rateIsHigherThanMaxAccepted
        ? `${disclaimerMessage}`
        : disclaimerMessage}
    </p>
  );

  const showAvailabilityCheckbox =
    isDeveloperAvailabilityPresent &&
    !isAvailabilityUnknown &&
    developerAvailability.availabilityAnswer !== 'not-looking-for-job';

  const hasErrors = Object.keys(formErrors).length > 0;
  const firstKey = hasErrors ? Object.keys(formErrors)[0] : null;
  const firstError = hasErrors ? formErrors[firstKey]: null;

  const ErrorsToShow = () => {
    if (!firstError) return <span />
    let message = firstError;
    if (firstKey === 'dataIntegrityConfirmed') message = "Please accept the data integrity agreement.";
    else if (firstKey.includes('customQuestion')) message = "Please answer all relevant questions.";
    return (
      <div className="form-control-feedback">
        {message}
      </div>
    );
  }

  return (blockSubmissionReason || isJobClosedForJRFSubmission) ? (
    <Row className="job-interest-form__row">
      <Col span={24}>
            <div className="job-interest-form__demotivation">
              <ErrorIndicatorSvg />
              <span>{blockSubmissionReason || 'Hiring for this position is currently paused. Please close this form and check other open jobs.'}</span>
            </div>
      </Col>
    </Row>
  ) : (
    <>
      <Row className="job-interest-form__row">
          <Col span={24}>
            <div className="job-interest-form__motivation">
              <InfoSvg />
              <span>To apply to this job, please fill up this form. Also, remember you’ll need to
                pass all the required Tests in order to be considered for this role.</span>
            </div>
          </Col>
        <Col span={24}>
          <div className="job-interest-form__question__heading">
            {++sectionCount}. {interestQuestion?.questionText || 'Are you interested in this position?'}
          </div>
          <Field name="isInterested" type="radio" value={values.isInterested}>
            {({ input, meta }) => (
              <RenderRadioGroup
                meta={meta}
                input={input}
                isVertical={true}
                disabled={!isSubmitAllowed}
                radioItems={[
                  {
                    label: interestQuestion ? 'Yes' : 'Yes, I am interested',
                    key: true,
                  },
                  {
                    label: interestQuestion ? 'No' : 'No, I am not interested',
                    key: false,
                  },
                ]}
                labelKey="label"
                valueKey="key"
                data-cy="job-interested-status"
              />
            )}
          </Field>
        </Col>
      </Row>

      {values.isInterested ? (
        <>
          {!advancedConfiguration ? (
            <>
              <Row className="job-interest-form__row">
                <Col span={24}>
                  <div className="job-interest-form__question">
                    <div className="job-interest-form__question__heading">
                      <span>{++sectionCount}. Type of Availability and Notice period</span>
                      {isAvailabilityUnknown && <span className="required">*</span>}
                    </div>
                    {isDeveloperAvailabilityPresent ? (
                      <>
                        <Row className="job-interest-form__question__row">
                          <Col lg={6} className="job-interest-form__question__info-bold">
                            Your Availability:
                          </Col>
                          <Col>
                        <span>
                          {`${findAvailabilityAnswerLabel(developerAvailability.availabilityAnswer)
                            ? `${findAvailabilityAnswerLabel(
                              developerAvailability.availabilityAnswer,
                            )}, `
                            : ''
                          }`}
                          {developerAvailability.availabilityAnswer !== 'not-looking-for-job'
                            ? `${findAvailabilityTypeIdLabel(
                              developerAvailability.availabilityTypeId,
                            )}`
                            : '.'}
                          {developerAvailability.availabilityAnswer !== 'not-looking-for-job' ? (
                            <span>
                              <span>
                                {developerAvailability.availabilityTypeId === 'fulltime'
                                  ? ' (8 hrs/day, 40 hrs/week)'
                                  : ' (4 hrs/day, 20 hrs/week)'}
                                &nbsp;
                              </span>
                            </span>
                          ) : null}
                        </span>
                          </Col>
                        </Row>
                        {developerAvailability.availabilityAnswer !== 'not-looking-for-job' ? (
                          <Row>
                            <Col lg={6} className="job-interest-form__question__info-bold">
                              Your Notice Period:
                            </Col>
                            <Col>
                          <span>
                            {developerAvailability.noticePeriod !== 0
                              ? <>Start in <span className="text-red">{developerAvailability.noticePeriod} {developerAvailability.noticePeriod > 1 ? 'weeks' : 'week'
                              }</span> from the date of selection (contract signing)</>
                              : 'Immediate Joining'}
                          </span>
                            </Col>
                          </Row>
                        ) : null}
                      </>
                    ) : (
                      <p className="job-interest-form__question__info">Your availability is not set.</p>
                    )}
                  </div>
                  {showAvailabilityCheckbox && (
                    <Field type="checkbox" name="availabilityConfirmed">
                      {({ input, meta }) => (
                        <RenderCheckboxField
                          title="Yes, I confirm"
                          errorText={submittedOnce && formErrors.availabilityConfirmed}
                          meta={meta}
                          input={input}
                          isInline
                          required
                          disabled={!isSubmitAllowed}
                          name="availabilityConfirmed"
                        />
                      )}
                    </Field>
                  )}
                  {isSubmitAllowed && (
                    <Button
                      loading={isAvailabilityModalLoading}
                      className="job-interest-form__button"
                      data-cy="job-interest-form__button__set-availability"
                      onClick={() => {
                        setIsAvailabilityModalLoading(true);
                        setTimeout(() => {
                          setIsAvailabilityModalLoading(false);
                          setAvailabilityModalVisible(true);
                        }, 500);
                      }}
                    >
                      {isDeveloperAvailabilityPresent
                        ? 'No, I want to update'
                        : 'Add your availability *'}
                    </Button>
                  )}
                  {submittedOnce &&
                  Boolean(formErrors.availabilityConfirmed) &&
                  !showAvailabilityCheckbox ? (
                    <div className="form-control-feedback">{formErrors.availabilityConfirmed}</div>
                  ) : null}
                  {isAvailabilityModalVisible && (
                    <Suspense fallback={<Spin size="large" className="job-interest-form__spinner" />}>
                      <AvailabilityModalV3
                        visible={isAvailabilityModalVisible}
                        availability={developerAvailability}
                        loadData={false}
                        closeAvailabilityModal={() => setAvailabilityModalVisible(false)}
                        handleUserIsAvailableChange={(
                          availability,
                          availabilityObj = {}
                        ) => {
                          const savedAvailability = {
                            availabilityTypeId: availabilityObj.current_status,
                            noticePeriod: availabilityObj.starts_in_weeks,
                            availabilityAnswer: availabilityObj.availability_answer,
                          };
                          setDeveloperAvailability(savedAvailability);
                          setIsDeveloperAvailabilityPresent(true);
                          onDeveloperAvailabilityChange();
                        }}
                      />
                    </Suspense>
                  )}
                </Col>
              </Row>

              <>
                <Row className="job-interest-form__row">
                  <Col span={24}>
                    <div className="job-interest-form__question">
                      <div className="job-interest-form__question__heading">
                        {++sectionCount}. Confirm your timezone
                      </div>
                      <Field style={{ width: 260 }} name="developerTimezoneId">
                        {({ input, meta }) => (
                          <>
                            <Select
                              {...input}
                              meta={meta}
                              className="form-field"
                              showSearch
                              disabled={!isSubmitAllowed}
                              style={{ width: 260 }}
                              placeholder=""
                              data-cy="developer-timezone"
                              optionFilterProp="children"
                              options={timezones.map((el) => {
                                return {
                                  value: el.id,
                                  label: getUTCTimezoneLabel(el.name, el.utcOffset),
                                };
                              })}
                            >
                              {timezones.map((el) => {
                                return <Select.Option value={el.id}>{getUTCTimezoneLabel(el.name, el.utcOffset)}</Select.Option>
                              })}
                            </Select>
                            {Boolean(formErrors.developerTimezoneId) ? (
                              <div className="form-control-feedback">
                                {formErrors.developerTimezoneId}
                              </div>
                            ) : null}
                          </>
                        )}
                      </Field>
                    </div>
                  </Col>
                </Row>
                <Row className="job-interest-form__row">
                  <Col span={24}>
                    <div className="job-interest-form__question">
                      <div className="job-interest-form__question__heading">
                        {++sectionCount}. Can you overlap for at least{' '}
                        {jobInterestDefaultDetails.jobOverlapHours} hours with the customer work hours?
                      </div>
                      <div className="">
                        <Row>
                          <Col lg={6} className="job-interest-form__question__info-bold">
                            Customer work hours:
                          </Col>
                          <Col>
                            {toAmPM(customerWorkHoursStart)} to {toAmPM(customerWorkHoursEnd)}{' '}
                            {(jobInterestDefaultDetails.jobTimezone || {}).popularName ||
                              (jobInterestDefaultDetails.jobTimezone || {}).name ||
                              ''}{' '}
                            (typical)
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={6} className="job-interest-form__question__info-bold">
                            Your time:
                          </Col>
                          <Col>{renderConvertedDeveloperWorkHours()}</Col>
                        </Row>
                      </div>
                    </div>
                    <Field
                      name="canOverlapWithTimezone"
                      type="radio"
                      value={values.canOverlapWithTimezone}
                    >
                      {({ input, meta }) => (
                        <RenderRadioGroup
                          meta={meta}
                          input={input}
                          isVertical
                          disabled={!isSubmitAllowed}
                          errorText={submittedOnce && formErrors.canOverlapWithTimezone}
                          radioItems={[
                            {
                              label: `Yes, I can overlap ${jobInterestDefaultDetails.jobOverlapHours} ${jobInterestDefaultDetails.jobOverlapHours > 1 ? 'hours' : 'hour'
                              } with the customer`,
                              key: true,
                            },
                            {
                              label: `No, I cannot overlap ${jobInterestDefaultDetails.jobOverlapHours
                              } ${jobInterestDefaultDetails.jobOverlapHours > 1 ? 'hours' : 'hour'
                              } with the customer`,
                              key: false,
                            },
                          ]}
                          labelKey="label"
                          valueKey="key"
                          data-cy="developer-availability-status"
                        />
                      )}
                    </Field>
                  </Col>
                </Row>
              </>

              {enableIcfRateV2 ? (
                <Row className="job-interest-form__row" data-cy="job-interest-form-salary-row">
                  <Col span={24}>
                    <div className="job-interest-form__question">
                      <div className="job-interest-form__question__headingcontainer">
                        <div className="job-interest-form__question__heading">
                          {++sectionCount}. Confirm your rate
                        </div>
                        <Field name="rateType">
                          {({ input }) => (
                            <div className="job-interest-form__rate-type">
                              <Radio.Group
                                {...input}
                                buttonStyle="solid"
                                data-cy="job-interest-form__rate-type"
                              >
                                <Radio.Button
                                  value={HOURLY}
                                >
                                  Hourly
                                </Radio.Button>
                                <Radio.Button
                                  value={MONTHLY}
                                >
                                  Monthly
                                </Radio.Button>
                              </Radio.Group>
                            </div>
                          )}
                        </Field>
                        {rateIsHigherThanMaxAccepted ? (
                          <Alert
                            message=""
                            description={
                              <>
                                Most developers applying for this role are requesting up to{' '}
                                <b>
                                  {formatValueAsCurrency(
                                    values.rateType === HOURLY
                                      ? jobInterest.devMaxRate
                                      : jobInterest.devMaxRate * MONTHLY_HOURS_OF_WORK,
                                  )}{' '}
                                  / {values.rateType === HOURLY ? 'hr' : 'month'}
                                </b>
                                .
                                <br />
                                We recommend lowering your rate to increase your likelihood of being
                                selected.
                              </>
                            }
                            type="warning"
                            showIcon
                          />
                        ) : null}
                      </div>
                      <div>{renderRateInfo()}</div>
                    </div>
                    {isNegotiatedOrNewDesiredSalaryPresentV2 ? (
                      <Field type="checkbox" name="salaryConfirmed">
                        {({ input, meta }) => (
                          <RenderCheckboxField
                            title={
                              <span data-cy="salary-feedback">Yes, I confirm.</span>
                            }
                            meta={meta}
                            input={input}
                            errorText={submittedOnce && formErrors.salaryConfirmed}
                            isInline
                            required
                            disabled={!isSubmitAllowed}
                            name="salaryConfirmed"
                          />
                        )}
                      </Field>
                    ) : null}

                    {isSubmitAllowed && !isMaxAttemptsReached ? (
                      <Button
                        className="job-interest-form__button"
                        data-cy="job-interest-form__button__set-salary"
                        loading={isSalaryModalLoading}
                        onClick={() => setModalType(UPDATE_RATE_MODAL)}
                      >
                        {isNegotiatedOrNewDesiredSalaryPresent
                          ? 'No, I want to update'
                          : 'Add your expected rate *'}
                      </Button>
                    ) : null}

                    {submittedOnce &&
                    Boolean(formErrors.salaryConfirmed) &&
                    !isNegotiatedOrNewDesiredSalaryPresent ? (
                      <div className="form-control-feedback">
                        {isNegotiatedOrNewDesiredSalaryPresentV2 ? '' : formErrors.salaryConfirmed}
                      </div>
                    ) : null}

                    {isMaxAttemptsReached ? (
                      <p className="job-interest-form__question__limittext">
                        You have reached the limit for updating your rate. Please complete the rest of
                        the form and a team member will reach out to discuss your rate.
                      </p>
                    ) : null}

                    {jobInterest.devCurrency !== 'USD' && disclaimerParagraph}

                    {modalType === UPDATE_RATE_MODAL ? (
                      <Suspense fallback={<Spin size="large" className="job-interest-form__spinner" />}>
                        <UpdateRateModal
                          newDesiredSalaryHourly={values.newDesiredSalaryHourly}
                          devNteHourlyRate={jobInterest.devNteHourlyRate ? jobInterest.devNteHourlyRate : 0}
                          rateType={values.rateType}
                          devCurrencyRate={jobInterest.devCurrencyRate}
                          devCurrency={jobInterest.devCurrency}
                          temporaryRateData={temporaryRateData}
                          onOK={({ newDesiredSalaryHourly, newDesiredSalaryMonthly }) => {
                            setTemporaryRateData({
                              newDesiredSalaryHourly,
                              newDesiredSalaryMonthly,
                            });
                            const { devNteHourlyRate } = jobInterest || {};
                            if (!!devNteHourlyRate && newDesiredSalaryHourly > devNteHourlyRate) {
                              setTimeout(() => {
                                setModalType(CONFIRM_UPDATE_MODAL);
                              }, 500);
                              return;
                            }
                            saveRateForm({
                              newDesiredSalaryHourly,
                              newDesiredSalaryMonthly,
                            });
                            if (!!devNteHourlyRate && newDesiredSalaryHourly < devNteHourlyRate) {
                              setTimeout(() => {
                                setModalType(APPLY_TO_ALL_MODAL);
                              }, 500);
                            }
                          }}
                          onClose={closeModal}
                        />
                      </Suspense>
                    ) : null}

                    {modalType === CONFIRM_UPDATE_MODAL ? (
                      <Suspense fallback={<Spin size="large" className="job-interest-form__spinner" />}>
                        <ConfirmRateChangeModal
                          onOK={() => {
                            saveRateForm(temporaryRateData);
                            closeModal();
                          }}
                          onClose={() => {
                            closeModal();
                            setTimeout(() => {
                              setModalType(UPDATE_RATE_MODAL);
                            }, 500);
                          }}
                        />
                      </Suspense>
                    ) : null}

                    {modalType === APPLY_TO_ALL_MODAL ? (
                      <Suspense fallback={<Spin size="large" className="job-interest-form__spinner" />}>
                        <ApplyToAllJobsModal
                          newDesiredSalaryHourly={values.newDesiredSalaryHourly}
                          rateType={values.rateType}
                          onOK={({ keepSalaryChangeFutureJobs }) => {
                            setDeveloperExpectedRateDetails({
                              ...values,
                              keepSalaryChangeFutureJobs,
                            });
                            closeModal();
                          }}
                          onClose={() => {
                            setDeveloperExpectedRateDetails({
                              ...values,
                              keepSalaryChangeFutureJobs: null,
                            });
                            closeModal();
                          }}
                        />
                      </Suspense>
                    ) : null}
                  </Col>
                </Row>
              ) : (
                <Row className="job-interest-form__row" data-cy="job-interest-form-salary-row">
                  <Col span={24}>
                    <div className="job-interest-form__question">
                      <div className="job-interest-form__question__heading">
                        {++sectionCount}. Confirm salary expectations
                      </div>
                      {isNegotiatedOrNewDesiredSalaryPresent ? (
                        <p className="job-interest-form__question__info">
                          Your salary is set to&nbsp;
                          <span className="job-interest-form__question__info-bold">
                        $
                            {values.newDesiredSalaryMonthly ? values.newDesiredSalaryMonthly :
                              developerRateDetails.monthlyRateInUSD ? developerRateDetails.monthlyRateInUSD :
                                0}
                            /month.
                      </span>
                          &nbsp;This cannot be re-negotiated after you submit your application.
                        </p>
                      ) : (
                        <p className="job-interest-form__question__info">
                          Your expected salary is not set.
                        </p>
                      )}
                    </div>
                    {isNegotiatedOrNewDesiredSalaryPresent ? (
                      <Field type="checkbox" name="salaryConfirmed">
                        {({ input, meta }) => (
                          <RenderCheckboxField
                            title={
                              <span data-cy="salary-feedback">
                            {`Yes, $${values.newDesiredSalaryMonthly ? values.newDesiredSalaryMonthly :
                              developerRateDetails.monthlyRateInUSD ? developerRateDetails.monthlyRateInUSD :
                                0
                            }/month is correct`}
                          </span>
                            }
                            meta={meta}
                            errorText={submittedOnce && formErrors.salaryConfirmed}
                            input={input}
                            isInline
                            required
                            disabled={!isSubmitAllowed}
                            name="salaryConfirmed"
                          />
                        )}
                      </Field>
                    ) : null}

                    {isSubmitAllowed && (
                      <Button
                        className="job-interest-form__button"
                        data-cy="job-interest-form__button__set-salary"
                        loading={isSalaryModalLoading}
                        onClick={() => {
                          setIsSalaryModalLoading(true);
                          setTimeout(() => {
                            setIsSalaryModalLoading(false);
                            onMonthlyCompensationChange(isNegotiatedOrNewDesiredSalaryPresent);
                          }, 500);
                        }}
                      >
                        {isNegotiatedOrNewDesiredSalaryPresent
                          ? 'No, I want to update my expectations'
                          : 'Add your expected salary *'}
                      </Button>
                    )}
                    {changeConformationPopupVisible && (
                      <Suspense fallback={<Spin size="large" className="job-interest-form__spinner" />}>
                        <ConfirmSalaryUpdateModal
                          onOK={() => {
                            setChangeConformationPopupVisible(false);
                            setIsMonthlyCompensationModalVisible(true);
                          }}
                          onClose={() => setChangeConformationPopupVisible(false)}
                        />
                      </Suspense>
                    )}
                    {isMonthlyCompensationModalVisible && (
                      <Suspense fallback={<Spin size="large" className="job-interest-form__spinner" />}>
                        <UpdateMonthlyCompensationModal
                          newDesiredSalaryMonthly={values.newDesiredSalaryMonthly}
                          salaryChangeReason={values.salaryChangeReason}
                          keepSalaryChangeFutureJobs={values.keepSalaryChangeFutureJobs}
                          monthlyRateInUSD={developerRateDetails.monthlyRateInUSD ? developerRateDetails.monthlyRateInUSD : 0}
                          onOK={({
                                   newDesiredSalaryMonthly,
                                   salaryChangeReason,
                                   keepSalaryChangeFutureJobs,
                                 }) => {
                            setDeveloperExpectedRateDetails({
                              ...values,
                              newDesiredSalaryMonthly,
                              salaryChangeReason,
                              keepSalaryChangeFutureJobs,
                            });
                            setIsNegotiatedOrNewDesiredSalaryPresent(true);
                          }}
                          onClose={() => setIsMonthlyCompensationModalVisible(false)}
                        />
                      </Suspense>
                    )}
                  </Col>
                </Row>
              )}

              {enableAcademicFields && (
                <Row className="job-interest-form__row">
                  <Col span={24}>
                    <div className="job-interest-form__question">
                      <div className="job-interest-form__question__heading">
                        {++sectionCount}. Academic Performance
                      </div>
                      <p className="job-interest-form__question__info">
                        Turing may reach out to verify your education
                      </p>
                    </div>
                    <Field type="checkbox" name="scoreOption" value={values.scoreOption}>
                      {({ input, meta }) => (
                        <RenderRadioGroup
                          meta={meta}
                          input={input}
                          errorText={submittedOnce && formErrors.scoreOption}
                          radioItems={[
                            {
                              label: 'College Undergraduate GPA',
                              key: 'gpa',
                            },
                            {
                              label: 'Percentage',
                              key: 'percentage',
                            },
                          ]}
                          isVertical
                          labelKey="label"
                          valueKey="key"
                        />
                      )}
                    </Field>
                  </Col>
                  {values.scoreOption === 'gpa' && (
                    <>
                      <Col md={11}>
                        <Field name="maxAttainableGPA">
                          {({ input, meta }) => (
                            <RenderSelectField
                              selectOptions={[4, 5, 6, 7, 8, 9, 10]}
                              title="Max attainable GPA score"
                              meta={meta}
                              errorText={submittedOnce && formErrors.maxAttainableGPA}
                              input={input}
                            />
                          )}
                        </Field>
                      </Col>

                      <Col offset={2} md={11}>
                        <Field name="developerGPAScore">
                          {({ input, meta }) => (
                            <RenderFloatField
                              title="Your GPA score"
                              min={0}
                              max={values.maxAttainableGPA}
                              meta={meta}
                              input={input}
                              errorText={submittedOnce && formErrors.developerGPAScore}
                              precision={2}
                              disabled={!values.maxAttainableGPA}
                            />
                          )}
                        </Field>
                      </Col>
                    </>
                  )}

                  {values.scoreOption === 'percentage' && (
                    <>
                      <Col md={12}>
                        <Field name="percentage">
                          {({ input, meta }) => (
                            <RenderFloatField
                              title="Percentage"
                              min={0}
                              max={100}
                              meta={meta}
                              errorText={submittedOnce && formErrors.percentage}
                              input={input}
                              precision={2}
                            />
                          )}
                        </Field>
                      </Col>
                    </>
                  )}
                  <Col span={24}>
                    <Field name="gradingExtraDetails">
                      {({ input, meta }) => (
                        <RenderTextArea
                          rows={4}
                          meta={meta}
                          input={input}
                          errorText={submittedOnce && formErrors.gradingExtraDetails}
                          placeholder="Please explain in which university/college and department you achieve this GPA, the grading metric, and the maximum attainable grading and your score"
                          showCount
                          maxLength={200}
                        />
                      )}
                    </Field>
                  </Col>
                </Row>
              )}

              {!showPerfectFitQuestion ? null : (
                <Row className="job-interest-form__row">
                  <Col span={24}>
                    <div className="job-interest-form__question">
                      <div className="job-interest-form__question__heading">
                        {++sectionCount}. What makes you the perfect candidate for this role?
                      </div>
                      <p className="job-interest-form__question__info">
                        Please explain what makes you the perfect candidate for this role. Note that
                        your response will be forwarded to the client. Thus make sure to keep a
                        professional tone while writing.
                      </p>
                    </div>
                    <Field name="perfectFitQuestionAnswer">
                      {({ input, meta }) => (
                        <RenderTextArea
                          rows={4}
                          meta={meta}
                          input={input}
                          disabled={!isSubmitAllowed}
                          errorText={submittedOnce && formErrors.perfectFitQuestionAnswer}
                          placeholder="Write your client introduction here"
                          data-cy="job-interest-form-perfect-fit-answer"
                        />
                      )}
                    </Field>
                  </Col>
                </Row>
              )}
            </>
          ) : null}

          {jobInterestDefaultDetails.customQuestionAnswerJson ? (
            <FieldArray name="customQuestionAnswerJson">
              {({ fields }) =>
                fields.map((name, index) => (
                  <CustomQuestionField
                    key={name}
                    name={name}
                    getSectionCount={() => ++sectionCount}
                    question={fields.value[index]}
                    isSubmitAllowed={isSubmitAllowed}
                    submittedOnce={submittedOnce}
                    jobInfo={jobInfo}
                    formErrors={formErrors}
                  />
                ))
              }
            </FieldArray>
          ) : null}

          {!advancedConfiguration && showOldCustomQuestion ? (
            <Row className="job-interest-form__row">
              <Col span={24}>
                <div className="job-interest-form__question">
                  <div className="job-interest-form__question__heading">
                    {++sectionCount}. Please answer the following questions:
                  </div>
                  <p dangerouslySetInnerHTML={{
                    __html: jobInterestDefaultDetails.customQuestion,
                  }}>
                  </p>
                </div>
                <Field name="customQuestionAnswer">
                  {({ input, meta }) => (
                    <RenderTextArea
                      rows={4}
                      meta={meta}
                      input={input}
                      errorText={submittedOnce && formErrors.customQuestionAnswer}
                      disabled={!isSubmitAllowed}
                      placeholder="Your answer here..."
                      data-cy="job-interest-form-custom-question-answer"
                    />
                  )}
                </Field>
              </Col>
            </Row>
          ) : null}

          {!isProxyApplication ? (
            <Row className="job-interest-form__row">
              <Col className="job-interest-form__row-confirmation" span={24}>
                <Field type="checkbox" name="dataIntegrityConfirmed">
                  {({ input, meta }) => (
                    <RenderCheckboxField
                      title="I confirm that the data I’ve entered is correct."
                      meta={meta}
                      input={input}
                      disabled={!isSubmitAllowed}
                      isInline
                      errorText={submittedOnce && formErrors.dataIntegrityConfirmed}
                      name="dataIntegrityConfirmed"
                    />
                  )}
                </Field>

                <div className="job-interest-form__question__info">
                  By submitting your application you are confirming your willingness to interview with the client. Turing can’t guarantee the client will select you for an interview.{' '}
                  {createdByEmail ? (
                    <span>
                      In case you have any questions, please reach out to the Matcher responsible for the job:   {createdByEmail}
                    </span>
                  ) : null}
                </div>
              </Col>
            </Row>
          ) : null}
        </>
      ) : (
        <Row className="job-interest-form__row">
          <Col span={24}>
            <div className="job-interest-form__question">
              <div className="job-interest-form__question__heading">
                {++sectionCount}. Tell us why you’re not interested *
              </div>
              <p className="job-interest-form__question__info">
                This helps us to better match you for future jobs.
              </p>
            </div>
            <Field
              name="notInterestedReasonId"
              validate={required}
              type="radio"
              value={values.notInterestedReasonId}
            >
              {({ input, meta }) => (
                <RenderRadioGroup
                  meta={meta}
                  input={input}
                  isVertical
                  radioItems={notInterestedReasons}
                  disabled={!isSubmitAllowed}
                  labelKey="reasonText"
                  valueKey="id"
                  data-cy="developer-not-interested-reason"
                />
              )}
            </Field>
            <div className="gutter-top-md">
              <Field name="notInterestedFeedback">
                {({ input, meta }) => (
                  <RenderTextArea
                    rows={4}
                    meta={meta}
                    input={input}
                    disabled={!isSubmitAllowed}
                    placeholder="Enter feedback"
                    data-cy="developer-not-interested-feedback"
                  />
                )}
              </Field>
            </div>
          </Col>
        </Row>
      )}

      {Object.keys(formErrors).length > 0 && <ErrorsToShow /> }

      {!isProxyApplication ? (
        <Row className="job-interest-form__submit" data-cy="job-interest-form__submit-section">
          {jobMatchingVetsmithFlag && isVetsmithFlow && values.isInterested ? (
            <SubmitButton
              submitting={submitting}
              pristine={pristine}
              onClick={() => {
                if (!submittedOnce) {
                  setSubmittedOnce(true);
                }
              }}
              label={isSubmitAllowed ? 'Continue' : 'Submitted'}
              disabled={!isSubmitAllowed || submitting || pristine || hasErrors}
              data-cy="job-interest-form__button-submit__with-vetsmith"
            >{isSubmitAllowed ? 'Submit and continue' : 'Submitted'}</SubmitButton>
          ) : (
            <SubmitButton
              submitting={submitting}
              pristine={pristine}
              onClick={() => {
                if (!submittedOnce) {
                  setSubmittedOnce(true);
                }
              }}
              label={isSubmitAllowed ? 'Submit' : 'Submitted'}
              disabled={!isSubmitAllowed || submitting || pristine || hasErrors}
              data-cy="job-interest-form__button-submit"
            >{isSubmitAllowed ? 'Submit' : 'Submitted'}</SubmitButton>
          )}
        </Row>
      ) : null}
    </>
  );
}
